import ChatMetadataProvider from "@/elements/components/chat/chat-metadata-provider";
import ParentChatList from "@/elements/components/chat/parent-chat-list";
import TutorChatList from "@/elements/components/chat/tutor-chat-list";
import Loader from "@/elements/components/shared/loader";
import { api } from "@/elements/components/utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import React, { Fragment } from "react";

function ChatScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {}),
  );

  const persona = currentUser?.persona;

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return persona === "parent" ? (
    <ParentChatList />
  ) : persona === "tutor" ? (
    <TutorChatList />
  ) : (
    <Fragment />
  );
}

export default ChatScreen;

